import React, { Fragment } from "react";
import "../../styles/whatCanDo.scss";
import {
  enhanceEnglish,
  getExpertGuidance,
  masterScience,
  keepNotesOrganized,
  masterCurrent,
  medicalTestExpert,
  dailyFitnessExpert,
  unlimitedMockInterviews,
  chemistryConcepts,
  videoNotesfeature,
  geographyExperts,
} from "../../assets/images";

const WhatCanDo = () => {
  return (
    <Fragment>
      <div className="container">
        <div className="why_choose_us_ssb_gpt">
          <h1 className="title">What Can You Do with SSB-GPT?</h1>
          <div className="card_list">
            <div className="card">
              <img src={getExpertGuidance} alt="crack cds exam" />
              <h2>Crack CDS Exam with Expert Mentorship</h2>
              <p>
                Get personalized guidance, study plans, and exam strategies
                tailored to your strengths and weaknesses.
              </p>
            </div>
            <div className="card">
              <img src={dailyFitnessExpert} alt="daily fitness coaching" />
              <h2>Daily Fitness Coaching for Defence Aspirants</h2>
              <p>
                Follow expert-designed routines to build strength, stamina, and
                pass armed forces physical standards.
              </p>
            </div>
            <div className="card">
              <img src={keepNotesOrganized} alt="keep notes organized" />
              <h2>Keep Your Notes Organized</h2>
              <p>
                Save and organize screenshots, images, text, and videos. Evolve
                your note-taking with all-in-one digital access. Stay organized
                and access your notes anytime, anywhere.
              </p>
            </div>
            <div className="card">
              <img src={videoNotesfeature} alt="video notes feature" />
              <h2>Video Notes Feature</h2>
              <p>
                Easily find videos related to your questions, add notes directly
                within the video for future reference, and save everything in
                your notes for convenient access.
              </p>
            </div>
            <div className="card">
              <img src={medicalTestExpert} alt="medical tests" />
              <h2>Understand Medical Tests and Standards Clearly</h2>
              <p>
                Know medical eligibility, avoid disqualifications, and prepare
                for real-time medical assessments.
              </p>
            </div>
            <div className="card">
              <img src={masterScience} alt="general science" />
              <h2>Master General Science for CDS with Ease</h2>
              <p>
                Grasp NCERT concepts in Physics, Chemistry, and Biology through
                visual learning and quizzes.
              </p>
            </div>
            <div className="card">
              <img src={chemistryConcepts} alt="chemistry concepts" />
              <h2>Make Chemistry Concepts Crystal Clear</h2>
              <p>
                Learn important reactions, formulas, and exam-relevant theory
                with step-by-step guidance.
              </p>
            </div>
            <div className="card">
              <img src={unlimitedMockInterviews} alt="history revision" />
              <h2>Revise History the Smart Way</h2>
              <p>
                Cover ancient, medieval, and modern history with timeline charts
                and key event summaries.
              </p>
            </div>
            <div className="card">
              <img src={geographyExperts} alt="geography" />
              <h2>Score High in Geography</h2>
              <p>
                Master physical, political, and Indian geography with visual
                tools and map-based questions.
              </p>
            </div>
            <div className="card">
              <img src={getExpertGuidance} alt="physics foundation" />
              <h2>Build Strong Foundation in Physics Concepts</h2>
              <p>
                Understand formulas, laws, and applications with real-life
                examples and exam-oriented practice.
              </p>
            </div>

            <div className="card">
              <img src={masterCurrent} alt="current affairs" />
              <h2>Master Current Affairs for CDS</h2>
              <p>
                Prepare for your NDA exam effortlessly. Get daily current
                affairs updates without the hassle of multiple newspapers.
              </p>
            </div>

            <div className="card">
              <img src={enhanceEnglish} alt="enhance english" />
              <h2>Enhance Your English with CDS-GPT</h2>
              <p>
                Improve your English communication skills with CDS-GPT. Get
                tailored practice and feedback for effective speaking and
                writing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default WhatCanDo;
